export default __webpack_public_path__ + "static/media/cj_header_logo_black.86f9508e.svg";